import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const committeesSteps = (ctx: TourStepContext): StepType[] => {
  const steps: StepType[] = [
    {
      selector: '[data-tour="committees-table"]',
      content:
        'Os Comitês são grupos responsáveis pela aprovação de demandas nos diferentes estágios do processo PMO. Cada comitê tem quórum mínimo e membros definidos.',
    },
  ];

  if (ctx.hasPermission('edit_read_delete')) {
    steps.push({
      selector: '[data-tour="committees-new-btn"]',
      content:
        'Crie um novo comitê definindo nome, escopo, quórum mínimo, votos necessários e membros participantes.',
    });
  }

  return steps;
};

export const intakeTriageSteps = (ctx: TourStepContext): StepType[] => {
  const steps: StepType[] = [
    {
      selector: '[data-tour="triage-table"]',
      content:
        'Esta é a fila de aprovação de demandas. O comitê avalia cada ficha de triagem e decide se ela avança para os próximos bridges ou é rejeitada.',
    },
  ];

  if (ctx.hasPermission('edit_read_delete')) {
    steps.push(
      {
        selector: '[data-tour="triage-approve-btn"]',
        content:
          'Clique em aprovar para aceitar a demanda e permitir que ela avance para o Bridge 1.',
      },
      {
        selector: '[data-tour="triage-reject-btn"]',
        content:
          'Clique em rejeitar para recusar a demanda, registrando o motivo da decisão.',
      },
    );
  }

  return steps;
};
